var _rect, _path, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoomLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 5.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 46.8245C36.2122 46.8245 33.1755 43.7551 33.1755 40C33.1755 36.2449 36.2449 33.1755 40 33.1755C43.7551 33.1755 46.8245 36.2449 46.8245 40C46.8245 43.7551 43.7878 46.8245 40 46.8245ZM64 37.4857H49.3714L62.0408 30.1714L59.5265 25.8286L46.8571 33.1429L54.1714 20.4735L49.8286 17.9592L42.5143 30.6286V16H37.4857V30.6286L30.1714 17.9592L25.8286 20.4735L33.1429 33.1429L20.4735 25.8286L17.9592 30.1714L30.6286 37.4857H16V42.5143H30.6286L17.9592 49.8286L20.4735 54.1714L33.1429 46.8571L25.8286 59.5265L30.1714 62.0408L37.4857 49.3714V64H42.5143V49.0776L49.9592 61.9755L54.0408 59.6245L46.5959 46.6939L59.5265 54.1714L62.0408 49.8286L49.3714 42.5143H64V37.4857Z",
    fill: "#16192C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 79,
    rx: 5.5,
    stroke: "#EDF2F7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoomLogo);
export default __webpack_public_path__ + "static/media/Loom_Logo.8469dd69d20cad803d26b5c1bf9ed7cb.svg";
export { ForwardRef as ReactComponent };